import { IRootState } from 'affiny-core/modules/state';

/* ***** *****  Auth  ***** ***** */

export const selectAccessToken = (state: IRootState) =>
  state.auth.token && state.auth.token.access_token;
